import toast from "react-hot-toast";
import { isDesktopDevice } from "../../commons/util/helperFunctions";
import { getAppConfig } from "commons/util/appConfigHelper";

const notifConfig = {
  duration: 2000,
  position: isDesktopDevice() || getAppConfig("AD_THEME") ? "top-center" : "top-left",
  style: { zIndex: 9999999, position: "relative", top: getAppConfig("AD_THEME") ?"100px":"30px" },
};

class PushAlert {
  static success(text) {
    toast.success(text, { ...notifConfig, id: text });
  }

  static warning(text) {
    toast(
      (t) => <div onClick={() => toast.dismiss(t.id)}>{text}</div>,
      { ...notifConfig, id: text }
    );
  }

  static error(text) {
    toast.error(text, { ...notifConfig, id: text });
  }

  static info(text) {
    toast(
      (t) => <div onClick={() => toast.dismiss(t.id)}>{text}</div>,
      { ...notifConfig, id: text }
    );
  }
}

export default PushAlert;
